<span class='label'>Gas Fees</span>
<span class='amount'>
  <app-counter [value]='(transferFee$|async)!'></app-counter>
  @if (transferFeeUSD$|async; as feeUSD) {
    <app-question-tooltip [text]='feeUSD'></app-question-tooltip>
  }
</span>
